module.exports = "/_next/static/media/Video11.d25f086bc5c7a7548256b450501de436.mp4";